import { useQuery } from '@apollo/client/react'
import { Box, Center, Heading, chakra, Link, Separator, HStack } from '@chakra-ui/react'
import { SiteNavItem } from '@src/components/sco/nav/ScoSiteNavBar'
import { NextLink } from '@src/components/sco/utilities/NextLink'
import { gql } from '@src/lib/gql'
import { PageWithNavBar } from '@src/templates/PageWithNavBar'
import { useSearchParams } from 'next/navigation'
import React from 'react'

export default function Page() {
  const queryParams = useSearchParams()

  const page = parseInt(queryParams.get('page')) || 1
  const pageSize = 100

  const query = useQuery(
    gql`
      query {
        scoPlaybooks {
          id
          title
          slug
        }
      }
    `,
    {
      variables: {
        first: pageSize,
        skip: pageSize * (page - 1),
      },
    }
  )

  return (
    <PageWithNavBar>
      <Center bgColor={'bg.subtle'} padding={'3em 1em'}>
        <Heading as={'h1'}>
          {'Startups.com Sitemaps - Playbooks - Page '}
          {page}
        </Heading>
      </Center>
      <Box margin={'0 auto'} maxWidth={'600px'} padding={'1em'}>
        <Separator marginY={'1em'} />
        <HStack justify={'space-between'}>
          {page > 1 ? (
            <Link asChild variant={'underline'}>
              <NextLink href={`/sitemaps/playbooks?page=${page - 1}`}>Previous Page</NextLink>
            </Link>
          ) : (
            <Link asChild variant={'underline'}>
              <NextLink href={`/sitemaps`} prefetch={false}>
                Back to Sitemap
              </NextLink>
            </Link>
          )}

          {query?.data?.scoPlaybooks?.length === pageSize && (
            <Link asChild variant={'underline'}>
              <NextLink href={`/sitemaps/playbooks?page=${page + 1}`}>Next Page</NextLink>
            </Link>
          )}
        </HStack>
        <Separator marginY={'1em'} />
        <chakra.ul padding={'0 2em'}>
          {query?.data?.scoPlaybooks?.map(playbook => (
            <SitemapItem
              key={playbook.id}
              item={{
                linkProps: {
                  title: playbook.title,
                  href: `/playbooks/${playbook.slug}`,
                },
              }}
            />
          ))}
        </chakra.ul>
      </Box>
    </PageWithNavBar>
  )
}

const SitemapItem = (props: { item?: SiteNavItem; description?: string }) => {
  const { item } = props

  const title =
    item.linkProps?.title || item.linkProps?.children || item.buttonProps?.title || item.buttonProps?.children

  const href = item.href || item.linkProps?.href || item.buttonProps?.href || ''

  if (!href) {
    return <></>
  }

  return (
    <chakra.li>
      <Link asChild variant={'underline'}>
        <NextLink href={href} prefetch={false}>
          {title}
        </NextLink>
      </Link>
      <p>{}</p>
      {item.items && (
        <chakra.ul padding={'0 2em'}>
          {item.items.map((subitem, key) => (
            <SitemapItem key={key} item={subitem} />
          ))}
        </chakra.ul>
      )}
    </chakra.li>
  )
}
